/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconDice2 = createSolidComponent("dice-2", "IconDice2", [
  [
    "path",
    {
      d: "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }
  ],
  ["circle", { cx: "9.5", cy: "9.5", r: ".5", fill: "currentColor" }],
  ["circle", { cx: "14.5", cy: "14.5", r: ".5", fill: "currentColor" }]
]);

export { IconDice2 as default };
//# sourceMappingURL=IconDice2.js.map
